import { queryOptions } from '@tanstack/react-query';

import type { PortfolioImportPageData } from './get-portfolio-import-page-data.ts';
import { getPortfolioImportPageData } from './get-portfolio-import-page-data.ts';

interface GetPortfolioImportPageDataQueryOptionsInput {
	readonly portfolioId: number;
}

export const PORTFOLIO_IMPORT_PAGE_QUERY_KEY = ['portfolio-import-page'] as const;

export function getPortfolioImportPageQueryKey({ portfolioId }: GetPortfolioImportPageDataQueryOptionsInput) {
	return [...PORTFOLIO_IMPORT_PAGE_QUERY_KEY, portfolioId] as const;
}

export function getPortfolioImportPageDataQueryOptions({ portfolioId }: GetPortfolioImportPageDataQueryOptionsInput) {
	return queryOptions<PortfolioImportPageData>({
		queryFn: () =>
			getPortfolioImportPageData({
				data: {
					portfolioId,
				},
			}),
		queryKey: getPortfolioImportPageQueryKey({ portfolioId }),
	});
}
